<template>
  <div class="modal fade" data-backdrop="static" id="create-package-from-batch" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-info bg-light">
            <h3 class="block-title"><i class="fa fa-box-open text-white"></i> Create package</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close" @click.prevent="clearData()">
                <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group required">
              <label class="control-label">Plant Batch Id</label>
              <input v-model="batchId" name="plantbatch_id" type="text" class="form-control form-control-alt" v-validate="'required'" data-vv-as="Plantbatch ID" placeholder="Plant Batch Id" />
              <p v-if="errors.has('plantbatch_id')" class="errorMsg">{{ errors.first('plantbatch_id') }}</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Plant Batch Name</label>
              <input v-model="batchName" name="plantbatch_name" type="text" class="form-control form-control-alt" v-validate="'required'" data-vv-as="Plantbatch Name" placeholder="Plant Batch Name" />
              <p v-if="errors.has('plantbatch_name')" class="errorMsg">{{ errors.first('plantbatch_name') }}</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Count</label>
              <input v-model="count" name="count" type="text" class="form-control form-control-alt" v-validate="'required'" data-vv-as="Count" placeholder="Count" />
              <p v-if="errors.has('count')" class="errorMsg">{{ errors.first('count') }}</p>
            </div>
            <div class="form-group">
              <label>Room</label>
              <select id="room" class="form-control form-control-alt select2-dropdown" style="width: 100%;" placeholder="Select Room..">
                <option></option>
                <option :value="room.Name" v-for="(room, index) in library.rooms" :key="index">{{ room.Name }}</option>
              </select>
            </div>
            <div class="form-group required">
              <label class="control-label">Item</label>
              <select id="item" class="form-control form-control-alt select2-dropdown" style="width: 100%;" placeholder="Select Item..">
                <option></option>
                <option :value="item.Name" v-for="(item, index) in library.items" :key="index">{{ item.Name }}</option>
              </select>
              <p v-if="itemError" class="errorMsg">The Item field is required.</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Tag</label>
              <input v-model="tag" name="tag" type="text" class="form-control form-control-alt" v-validate="'required'" data-vv-as="Tag" placeholder="Tag">
              <p v-if="errors.has('tag')" class="errorMsg">{{ errors.first('tag') }}</p>
            </div>
            <div class="form-group">
              <label>Actual Date</label>
              <input v-model="date" id="package-date" type="text" class="form-control form-control-alt datepicker" placeholder="Date">
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click.prevent="createPackage()" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i><span>Save</span></div>
                <span class="modal-loader" v-if="showModalLoader">
                  <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
                </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapState, mapActions } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'CreatePackageFromPlantBatch',
  data() {
    return {
      batchId: '',
      batchName: '',
      count: '',
      room: '',
      item: '',
      tag: '',
      date: new Date().toJSON().slice(0,10),
      plantBatch: null,
      itemError: false,
      showModalLoader: false,
      errorMsg: ''
    };
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  mounted() {
    $('.datepicker').datepicker({ format: 'yyyy-mm-dd', autoclose:true });
    let vm = this, item = $('#item'), room = $('#room');
    item.on('change', function() { vm.itemError = false; vm.item = item.val();});
    room.on('change', function() { vm.room = room.val();});
    $('#package-date').change(function() { vm.date = $(this).val(); });
  },
  components: {
    HashLoader
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['getAllPackages']),
    clearData() {
      this.batchId = '';
      this.batchName = '';
      this.count = '';
      this.room = '';
      this.item = '';
      this.tag = '';
      this.errorMsg = '';
      this.date = new Date().toJSON().slice(0,10);
      $('.select2-dropdown').val(null).trigger('change');
      $('.datepicker').datepicker('update', this.date);
      this.$validator.reset();
    },
    setPlantBatchDetails(plantBatch) {
      this.batchName = plantBatch.Name;
      this.batchId = plantBatch.Id;
    },
    createPackage() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (vm.validateSelectBox() && valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest(
            '/plantbatches/createpackages',
            {
              Id: vm.batchId,
              PlantBatch: vm.batchName,
              Count: vm.count,
              Room: vm.room,
              Item: vm.item,
              Tag: vm.tag,
              ActualDate: vm.date
            }
          ).then((data) => {
            if (data.status === 'success') {
              vm.getAllPackages();
              jQuery('#create-package-from-batch').modal('hide');
              vm.clearData();
              vm.$emit('showSuccessMsg', data.message);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    },
    validateSelectBox() {
      this.itemError  = false;
      if (this.item === '') {
        this.itemError = true;
      }
      if (this.itemError) {
        return false;
      }
      return true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// source/components/modals/CreatePackageFromPlantBatch.vue